export const DRAWER_WIDTH_COLLAPSED = 70;
export const DRAWER_WIDTH_EXPANDED = 224;
